import { ICharacterItem, ICharacterInfo } from '../interface/IMyCharList';
import { l10nAllLang } from '../common/L10n';
import { getLang } from '../common/Utils';

export const _getCharacterInfoByService = ({ level, characterName, name, classCardName, gameClassName, className, guildName, clan, companyName, lastLoginDate, loginTime, loginTimeZ }: ICharacterItem): string => {
    const serviceName = document.getElementsByTagName('html')[0].getAttribute('data-service');
    let lastAccess = '';

    if (serviceName === 'bns2') {
        return _markupCharacterInfo({ level, name: characterName, guild: guildName });
    } else if (serviceName === 'tricksterm') {
        return _markupCharacterInfo({ level, name: characterName, classcard: className, guild: companyName });
    } else if (serviceName === 'lineage2m' || serviceName === 'lineage2mnaeu' || serviceName === 'lineage2mru' || serviceName === 'lineage2mnct' || serviceName === 'lineage2mncj') {
        lastAccess = _getLastAccess(serviceName, loginTimeZ);
        return _markupCharacterInfo({ level, name, classcard: classCardName, guild: clan ? clan.name : '', lastAccess });
    } else if (serviceName === 'lineagew') {
        return _markupCharacterInfo({ level, name: characterName, classcard: gameClassName, guild: clan ? clan.name : '' });
    } else if (serviceName === 'lineagem') {
        lastAccess = _getLastAccess(serviceName, lastLoginDate);
        return _markupCharacterInfo({ level, name, guild: clan ? clan.name : '', lastAccess });
    } else {
        return _markupCharacterInfo({ level, name: characterName });
    }
};

const _markupCharacterInfo = ({ level, name, classcard, guild, lastAccess }: ICharacterInfo): string => {
    return `
        ${parseInt(level) > 0 ? `<span class="lv">LV. ${level}</span>` : ''}
        ${name ? `<strong class="name">${name}</strong>` : ''}
        ${classcard ? `<span class="classcard">${classcard}</span>` : ''}
        ${guild ? `<span class="guild">${guild}</span>` : ''}
        ${lastAccess ? `<span class="last-access">${lastAccess}</span>` : ''}`;
};

const _getLastAccess = (serviceName: string, lastAccessTime: string): string => {
    // const year = parseInt(lastAccessTime.split(' ')[0].split('-')[0]);
    // const month = lastAccessTime.split(' ')[0].split('-')[1];
    // const day = lastAccessTime.split(' ')[0].split('-')[2];
    const date = new Date(lastAccessTime);
    const year = date.getFullYear();
    const month = ('0' + (1 + date.getMonth())).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    const lang = getLang() || 'en';
    const loginTime = l10nAllLang[lang].myCharList.loginTime;

    if (serviceName === 'lineagem') {
        if (year > 1970) return `(${year}.${month}.${day}.${loginTime})`;
        else return '';
    } else return `(${year}.${month}.${day}. ${loginTime})`;
};
